<ng-container *ngIf="report$ | async as report">
  <app-page-header [title]="report.status === 'cancelled' ? 'Melding annuleren goedkeuren' : 'Melding goedkeuren'">
    <div class="actions ml-auto">
      <a class="btn btn-primary" (click)="approve(report)">Goedkeuren</a>
    </div>
  </app-page-header>

  <app-reports-details></app-reports-details>
</ng-container>
